import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './common.actions';
import { CommonState, initialCommonState } from './common.state';

const commonReducer = createReducer(
    initialCommonState,
    on(actions.loadSystemModules, state => ({ ...state, loading: true })),
    on(actions.loadSystemModulesSuccess, (state, action) => ({ ...state, systemModules: action.systemModules })),
    on(actions.loadSystemModulesFailed, (state, action) => ({ ...state, systemModules: [], error: action.error })),
);

export function reducer(state: CommonState | undefined, action: Action) {
    return commonReducer(state, action);
}
